import React from 'react';
import MuiTooltip, { TooltipProps } from '@mui/material/Tooltip';
import { tooltipSx } from './Tooltip.styles';
import { SxProps, Theme } from '@mui/material/styles';

export const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>((props, ref) => {
  return (
    <MuiTooltip
      ref={ref}
      {...props}
      sx={[tooltipSx, props.sx] as SxProps<Theme>}
    />
  );
});

Tooltip.displayName = 'Tooltip';